import React from "react";
import { Routes, Route } from "react-router-dom";



import Login from "../Pages/Login";
import Register from "../Pages/Register";
import Rgthanks from "../Pages/Rgthanks";
import Verify from "../Pages/Verify";


import Forgetpassword from "../Pages/Forgetpassword";
import Fgthanks from "../Pages/Fgthanks";
import Resetpass from "../Pages/Resetpass";
import Rsthanks from "../Pages/Rsthanks";
import Customer_verify from "../Pages/Customer_verify";





import P404 from "../Pages/P404";
import Header from "../Pages/inc/Header";
import Footer from "../Pages/inc/Footer";

export default function RootRouter() {


  return (
    <>

      <Header />
      <main>
        <Routes>

          <Route exact path="/" element={<Login />}></Route>
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/rgthanks" element={<Rgthanks />} />
          <Route exact path="/verify/:vid" element={<Verify />} />



          <Route exact path="/forgetpassword" element={<Forgetpassword />} />
          <Route exact path="/fgthanks" element={<Fgthanks />} />
          <Route exact path="/resetpass" element={<Resetpass />} />
          <Route exact path="/rsthanks" element={<Rsthanks />} />
          <Route exact path="/customer_verify" element={<Customer_verify />} />
          




          <Route exact path="/*" element={<P404 />} />




        </Routes>


      </main>
      <Footer />

      {/* <Helmet>
                    <script src="/assets/js/backToTop.js"></script>  
                  </Helmet> */}



    </>
  );
};

